
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M384,349.28c46.87,0,85,35.49,85,79.12V469H43V428.4c0-43.63,38.13-79.12,85-79.12H384m0-43H128C57.31,306.28,0,361,0,428.4V512H512V428.4c0-67.45-57.31-122.12-128-122.12ZM512,405.4v0Z","fill":"#fff"}}),_c('circle',{attrs:{"cx":"256","cy":"144","r":"128.17","fill":"#fff"}})])
      }
    
      }
    